module.exports = __webpack_public_path__ + "css/wechat.svg?ebd81bd4f78dce4295005eb1ae71e936";